// material-ui
import { useTheme } from '@mui/material/styles';

// project imports
import { ThemeMode } from 'config';

import logoDark from 'assets/images/logo-dark.png';
import logoLight from 'assets/images/logo-light.png';

// ==============================|| LOGO SVG ||============================== //

export default function LogoMain({ reverse }: { reverse?: boolean }) {
  const theme = useTheme();

  const isDarkMode = theme.palette.mode === ThemeMode.DARK;
  const logoSrc = reverse ? (isDarkMode ? logoLight : logoDark) : isDarkMode ? logoDark : logoLight;

  return <img src={logoSrc} alt="Tervify" width="100" />;
}
